module.exports = __webpack_public_path__ + "media/theme/icon__amex-c5a15767.png";